module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signin-modal-vertical-3c0829f4ceae7cd17d78873ead65cb17.jpg";